import { LoadableRoute } from 'routes/utils/loadable';

export const ForgotPasswordContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "ForgotPassword" */ './ForgotPassword'),
});
